import React, { FC } from "react";
import Page from "./common/navigation/Page";
import Button from "./common/F7/Button";
import Logo from "../images/logo.svg";

import config from "../config";

const AboutPage: FC = () => {
  return (
    <Page title="Piano by Sweco" noToolbar>
      <div
        style={{
          textAlign: "center",
          maxWidth: 600,
          padding: 20,
          paddingTop: 0,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <p>
          <img
            src={Logo}
            style={{
              width: 60,
              marginTop: 0,
            }}
            alt=""
          />
        </p>
        <h2>Piano is an inventory app with offline support</h2>

        <p>
          Create and display inventories on a map. If the device looses network connection you can continue to work offline and sync your
          data to the server when back online.
        </p>
        <p>
          <Button to="/">Open a database</Button>
        </p>
        <h2>Features</h2>

        <p>Add georeferenced points and form input</p>
        <p>
          <img
            src={Logo}
            style={{
              width: 15,
              marginTop: 0,
            }}
            alt=""
          />
        </p>
        <p>Manage your inventories in projects</p>
        <p>
          <img
            src={Logo}
            style={{
              width: 15,
              marginTop: 0,
            }}
            alt=""
          />
        </p>
        <p>Create your own forms with the formbuilder</p>
        <p>
          <img
            src={Logo}
            style={{
              width: 15,
              marginTop: 0,
            }}
            alt=""
          />
        </p>
        <p>Customize point color based on form input</p>
        <p>
          <img
            src={Logo}
            style={{
              width: 15,
              marginTop: 0,
            }}
            alt=""
          />
        </p>
        <p>Download background maps for offline use</p>
        <p style={{ opacity: 0.3, marginTop: 50 }}>v{config.version}</p>
      </div>
    </Page>
  );
};

export default AboutPage;
